import React from 'react'
import isAdmin from '../../../utilities/is-admin'
import isFacilitator from '../../../utilities/is-facilitator'
import isStudent from '../../../utilities/is-student'
import isTsc from '../../../utilities/is-tsc'

const RoleLabel = ({
    user = {}
}) => {
    const roles = []
    if (isAdmin(user)) {
        roles.push('Admin')
    }
    if (isFacilitator(user)) {
        roles.push('Facilitator')
    }
    if (isStudent(user)) {
        roles.push('Student')
    }
    if (isTsc(user)) {
        roles.push('TSC')
    }
    const rolesText = roles.length ? roles.join(', ') : 'UNAUTHORIZED'

    return (
        <React.Fragment>
            {rolesText}
        </React.Fragment>
    )
}

export default RoleLabel